import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export-ga-cost',
  templateUrl: './help-add-export-ga-cost.component.html',
  styleUrls: ['./help-add-export-ga-cost.component.scss']
})
export class HelpAddExportGaCostComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
